/**
 * `POST /api/cart/sync-logout` builder — re-tag cart rows under a guest id
 * after the user signs out. Fire-and-acknowledge from the call site
 * (cart-provider treats failures as "log + reload from server"); we still
 * throw on non-2xx so the caller's `.catch` runs.
 *
 * @see packages/contract/src/cart-sync-logout.ts — request/response contract
 * @see app/api/cart/sync-logout/route.ts — handler
 */

import type { CartSyncLogoutRequest } from "@kraahl/contract";

export interface SyncLogoutCartArgs {
  userId: string;
  guestId: string;
  signal?: AbortSignal;
}

export async function syncLogoutCart(args: SyncLogoutCartArgs): Promise<void> {
  const body: CartSyncLogoutRequest = {
    userId: args.userId,
    guestId: args.guestId,
  };

  const res = await fetch("/api/cart/sync-logout", {
    method: "POST",
    headers: { "Content-Type": "application/json" },
    body: JSON.stringify(body),
    ...(args.signal ? { signal: args.signal } : {}),
  });

  if (!res.ok) {
    throw new Error(`HTTP ${res.status}`);
  }
}
